// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dW9s","footer":"styles_footer__18o_b"};